import { equals, test, expect } from "@benchristel/taste"

export function repository<T>(
  key: string,
  store: { [key: string]: string },
  blankFactory: () => T,
) {
  return {
    load(): T {
      const storedData = store[key]
      return storedData ? JSON.parse(storedData) : blankFactory()
    },
    save(state: T) {
      store[key] = JSON.stringify(state)
    },
  }
}

const noop = () => ({})

test("pollRepository", {
  "returns a working model if in store"() {
    const store = { id: '{ "foo": "bar" }' }
    expect(repository<{}>("id", store, noop).load(), equals, {
      foo: "bar",
    })
  },
  "defaults to an empty model if there's nothing in local storage"() {
    expect(repository<{}>("foo", {}, () => ({})).load(), equals, {})
  },
})
